var _style, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "apple-music",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 120 120",
    style: {
      enableBackground: "new 0 0 120 120"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#9E9C9E;}\r\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M94,120H26c-14.3,0-26-11.6-26-25.9c0,0,0-0.1,0-0.1V26C0,11.7,11.6,0,25.9,0c0,0,0.1,0,0.1,0h68 c14.3,0,26,11.6,26,25.9c0,0,0,0.1,0,0.1v68c0,14.3-11.6,26-25.9,26C94.1,120,94,120,94,120z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M20.3,46.2h17.1v54.9H20.3C20.3,101.1,20.3,46.2,20.3,46.2z M28.8,18.9c5.5,0,9.9,4.4,9.9,9.9 c0,5.5-4.4,9.9-9.9,9.9c-5.5,0.1-10-4.2-10.1-9.7s4.2-10,9.7-10.1C28.6,18.9,28.7,18.9,28.8,18.9z M48.1,46.2h16.4v7.5h0.2 c2.3-4.3,7.8-8.9,16.1-8.9c17.3,0,20.5,11.4,20.5,26.1v30.1h-17V74.4c0-6.4-0.1-14.5-8.9-14.5c-8.9,0-10.2,6.9-10.2,14.1v27.1h-17 L48.1,46.2L48.1,46.2z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.dea75cf5fce0ea53a3ef3d1c86584818.svg";
export { ForwardRef as ReactComponent };